import styled from 'styled-components'
import { PrimaryButton } from 'ui/atoms/Button'
import H5 from 'syf-component-library/ui/typography/H5'
import query from 'syf-component-library/const/mediaQueries'
import config from 'const/config'

export const TryMeContainer = styled.div`
  min-height: 102px;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: left;
  border: 1px solid ${({ theme: { colors } }) => colors.lightGreyThree};
  box-shadow: 0px 4px 4px 0px
    ${({ theme: { opacities } }) => opacities.greyNinety};
  border-radius: 10px;
  background-color: ${({ theme: { colors } }) => colors.lightGreyBlue};
`

export const SyfLogo = styled.img.attrs({
  src: `${config.ASSET_ORIGIN}/assets/synchrony/logo.svg`,
  alt: 'synchrony'
})`
  height: 25px;
  width: auto;
  margin: 0 auto 0 auto;
`

export const TryMeBannerHeader = styled(H5)`
  width: 235px;
  line-height: 28px;
  color: ${({ theme: { colors } }) => colors.darkerCharcoal};

  @media ${query.lessThanMedium} {
    font-size: ${({ theme: { fontSize } }) => fontSize.twentyPixel};
  }
`

export const ActionsContainer = styled.div`
  width: 285px;
  height: 36px;
  display: flex;
  gap: 12px;
  color: ${({ theme: { colors } }) => colors.grey};
`

const Button = styled(PrimaryButton)`
  height: 36px;
  border-radius: 25px;
  padding: 8px;
  margin: 0;
`

export const GetStartedButton = styled(Button)`
  flex-grow: 1;
  background-color: ${({ theme: { colors } }) => colors.gold};
  color: ${({ theme: { colors } }) => colors.darkGreyBlue};
  border: 1px solid ${({ theme: { colors } }) => colors.gold};

  &:hover {
    background-color: ${({ theme: { colors } }) => colors.goldLight};
    border-color: ${({ theme: { colors } }) => colors.goldLight};
  }
`

export const SignInButton = styled(Button)`
  min-width: 94px;
  width: unset;
  background-color: ${({ theme: { colors } }) => colors.lightGreyBlue};
  color: ${({ theme: { colors } }) => colors.darkGreyBlue};
  border: 1px solid ${({ theme: { colors } }) => colors.darkGreyBlue};

  &:hover {
    background-color: ${({ theme: { colors } }) => colors.darkGreyBlue};
    color: ${({ theme: { colors } }) => colors.white};
  }
`
